import { registerPlugin } from "@capacitor/core";

export const PlayInAppUpdate = registerPlugin("PlayInAppUpdate");
